module.exports = __webpack_public_path__ + "static/media/1.558b0862.mp4";